import React, { useState, useEffect,useRef } from "react";
import { useRouter } from "next/router";
import styles from "./NavBar.module.css";
import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../../components/LoadingSpinner";
import Image from "next/image";
import close from "@/assets/icons/cancel-btn.svg";

const SearchMenu = ({ menuData }) => {
  const [dropdown, setDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ids, setId] = useState("");
  const [toggle, setToggle] = useState(null);
  const leaveTimeout = useRef(null);

  const router = useRouter();
  const dispatch = useDispatch();
  const { isMobileDevice } = useSelector((state:any) => state.data);

  const handleMouseEnter = (id) => {
    if (leaveTimeout.current) {
      clearTimeout(leaveTimeout.current);
    }
    setDropdown(true);
    setId(id);
  };

  const handleMouseLeave = () => {
    leaveTimeout.current = setTimeout(() => {
      setDropdown(false);
      setId("");
    }, 200);
  };

  useEffect(() => {
    const handleRouteChangeStart = () => setLoading(true);
    const handleRouteChangeComplete = () => setLoading(false);

    router.events.on("routeChangeStart", handleRouteChangeStart);
    router.events.on("routeChangeComplete", handleRouteChangeComplete);

    return () => {
      router.events.off("routeChangeStart", handleRouteChangeStart);
      router.events.off("routeChangeComplete", handleRouteChangeComplete);
    };
  }, [router.events]);

  const handleClick = (e, href) => {
    e.preventDefault();
    setLoading(true);
    router.push(href);
  };

  const handleBack = (val) =>{
    const name = val;
    setToggle(name)
  }


  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <ul className="navbar-nav me-auto pt-5 pt-lg-0 ps-4 ps-lg-0 mb-2 mb-lg-0">
      {menuData?.map((menuItem, index) => (
        <li
          key={index}
          className={`nav-item ${
            menuItem?.submenu && menuItem?.submenu?.results?.length > 0
              ? "dropdown"
              : ""
          }
              ${menuItem?.submenu && menuItem?.submenu?.results?.length > 0 && toggle == menuItem.name && "active"}
               me-4`}
               onMouseEnter={() => handleMouseEnter(menuItem.name)}
               onMouseLeave={handleMouseLeave}
        >
          {menuItem?.submenu && menuItem?.submenu?.results?.length > 0 ? (
            <>
              <a
                className={`nav-link dropdown-toggle ${styles.navText}`}
                href={menuItem.hyperlink || "#"}
                id={`navbarDropdown${index}`}
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                // data-bs-dismiss="modal"
                onClick={()=>handleBack(menuItem?.name)}
              >
                {menuItem.name}
              </a>
              <SubMenu
                submenu={menuItem?.submenu?.results}
                handleMouseEnter={handleMouseEnter}
                handleMouseLeave={handleMouseLeave}
                dropdown={dropdown}
                ids={ids}
                isMobileDevice={isMobileDevice}
                handleClick={handleClick}
                handleBack={handleBack}
                show={dropdown && ids === menuItem.name}
              />
            </>
          ) : (
            <a
              className={`nav-link ${styles.navText}`}
              onClick={(e)=>handleClick(e,menuItem?.hyperlink || "#")}
              data-bs-dismiss="modal"
            >
              {menuItem?.name}
            </a>
          )}
        </li>
      ))}
    </ul>
  );
};

const SubMenu = ({
  submenu,
  handleMouseEnter,
  handleMouseLeave,
  dropdown,
  ids,
  isMobileDevice,
  handleClick,
  handleBack,
  show
}) => {
  return (
    <ul
      className={`dropdown-menu ${
        submenu?.length < 5 ? "dropdownmenu_l2" : ""
      } ${show ? "show" : ""} `}
      aria-labelledby="navbarDropdown"
      onMouseEnter={() => handleMouseEnter(ids)}
      onMouseLeave={handleMouseLeave}
    >
       {  <div className="mobile-submenu-close justify-content-end"
           onClick={()=>handleBack(null)}
           >
                <button
                  className="navbar-toggler position-relative p-1 close"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarTogglerDemo02"
                  aria-controls="navbarTogglerDemo02"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <Image
                    src={close}
                    alt="Close"
                    width={24}
                    height={24}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />
                </button>
              </div> }
      {submenu.map((subItem, index) => (
        <li key={index}>
          {subItem.hyperlink ? (
            <div
              className={`${styles.submenu_wp} main_menu_mobile`}
              onMouseEnter={() => handleMouseEnter(ids)}
              onMouseLeave={handleMouseLeave}
            >
               <button
                  type="button"
                  className="mobile-sub-back btn px-0 mt-3 mb-4"
                  onClick={()=>handleBack(null)}
                >
                  {" < "}
                  <span>Back</span>
              </button>
              <a
                className={`dropdown-item ${
                  dropdown && ids === index && styles.menu_name_highlight
                } ${styles.left_side_lists}`}
                // href={subItem.hyperlink || "#"}
                onClick={(e) => handleClick(e, subItem?.hyperlink || "#")}
                        data-bs-dismiss="modal"
              >
                {subItem.name}
                {subItem.submenu?.results?.length > 0 && (
                  <span className={`${styles.navbar_arrow_icon}`}>{" > "}</span>
                )}
              </a>
              {subItem?.submenu?.results?.length > 0 && (
                <ul
                  className={`${styles.level_menu} ${styles.right_side_list}`}
                >
                  {subItem?.submenu?.results?.map((item, subIndex) => (
                    <li key={subIndex} className="dropdown-item submenu_1">
                      <a
                        className={`${styles.link_sub_item}`}
                        onClick={(e) => handleClick(e, item?.hyperlink || "#")}
                        data-bs-dismiss="modal"
                      >
                        {item?.name}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ) : (
            <span className="dropdown-item">{subItem.name}</span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default SearchMenu;
